"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PayspaceNotFound = PayspaceNotFound;

var _media = require("react-components/media");

var _designSystem = require("@slyk/design-system");

var _reactHelmet = require("react-helmet");

var _reactI18next = require("react-i18next");

var _styles = require("react-components/styles");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `Section` styled component.
 */
var Section = _styledComponents["default"].section.withConfig({
  displayName: "payspace-not-found__Section",
  componentId: "sc-1iws7e4-0"
})(["", ""], _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-column-gap: ", ";\n    grid-template-columns: repeat(12, 1fr);\n  "])), (0, _styles.units)(4)));
/**
 * `Header` styled component.
 */


var Header = _styledComponents["default"].header.withConfig({
  displayName: "payspace-not-found__Header",
  componentId: "sc-1iws7e4-1"
})(["display:none;grid-column:1 / span 6;position:relative;", ""], _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
/**
 * `StyledBackgroundImage` styled component.
 */


var StyledBackgroundImage = (0, _styledComponents["default"])(_media.BackgroundImage).withConfig({
  displayName: "payspace-not-found__StyledBackgroundImage",
  componentId: "sc-1iws7e4-2"
})(["background-size:contain;"]);
/**
 * `IconWrapper` styled component.
 */

var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "payspace-not-found__IconWrapper",
  componentId: "sc-1iws7e4-3"
})(["left:", ";position:absolute;top:", ";"], (0, _styles.units)(3), (0, _styles.units)(4));
/**
 * `Main` styled component.
 */


var Main = _styledComponents["default"].main.withConfig({
  displayName: "payspace-not-found__Main",
  componentId: "sc-1iws7e4-4"
})(["display:flex;flex-direction:column;height:100vh;overflow-y:auto;", ""], _styles.media.min('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: span 6 / -1;\n    padding-right: ", ";\n  "])), (0, _styles.units)(4)));
/**
 * `ContentWrapper` styled component.
 */


var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "payspace-not-found__ContentWrapper",
  componentId: "sc-1iws7e4-5"
})(["display:flex;flex:1;flex-direction:column;margin:0 auto;max-width:343px;padding:0 ", " 0;width:100%;", " ", ""], (0, _styles.units)(2), _styles.media.min('ms')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    max-width: 410px;\n  "]))), _styles.media.min('md')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    padding: 0;\n  "])), (0, _styles.units)(56)));
/**
 * `Content` styled component.
 */


var Content = _styledComponents["default"].div.withConfig({
  displayName: "payspace-not-found__Content",
  componentId: "sc-1iws7e4-6"
})(["display:flex;flex:1;flex-direction:column;justify-content:center;"]);
/**
 * `StyledLink` styled component.
 */


var StyledLink = (0, _styledComponents["default"])(_designSystem.Link).withConfig({
  displayName: "payspace-not-found__StyledLink",
  componentId: "sc-1iws7e4-7"
})(["margin:", " 0 ", " ", ";width:max-content;", ""], (0, _styles.units)(4), (0, _styles.units)(2), (0, _styles.units)(2), _styles.media.min('md')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
/**
 * `StyledImage` styled component.
 */

var StyledImage = (0, _styledComponents["default"])(_media.Image).withConfig({
  displayName: "payspace-not-found__StyledImage",
  componentId: "sc-1iws7e4-8"
})(["", ""], _styles.media.min('md')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
/**
 * `ActionWrapper` styled component.
 */

var ActionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "payspace-not-found__ActionWrapper",
  componentId: "sc-1iws7e4-9"
})(["padding:", " 0 ", ";", ""], (0, _styles.units)(3), (0, _styles.units)(7), _styles.media.min('md')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "])), (0, _styles.units)(9)));
/**
 * Export `PayspaceNotFound` component.
 */


function PayspaceNotFound(props) {
  var backgroundImage = props.backgroundImage,
      backgroundOverlay = props.backgroundOverlay,
      earlyAccessLink = props.earlyAccessLink,
      imageMobile = props.imageMobile,
      logoLink = props.logoLink,
      supportEmail = props.supportEmail;

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, translate('payspaceNotFound.metaTitle'))), /*#__PURE__*/_react["default"].createElement(Section, null, /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(_media.BackgroundImage, backgroundOverlay), /*#__PURE__*/_react["default"].createElement(StyledBackgroundImage, backgroundImage), /*#__PURE__*/_react["default"].createElement(IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
    href: logoLink,
    rel: 'noopener',
    target: '_blank'
  }, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: (0, _styles.color)('white'),
    icon: _designSystem.logo,
    size: (0, _styles.units)(12.5)
  })))), /*#__PURE__*/_react["default"].createElement(Main, null, /*#__PURE__*/_react["default"].createElement(StyledLink, {
    href: logoLink,
    rel: 'noopener',
    target: '_blank'
  }, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: (0, _styles.color)('primary'),
    icon: _designSystem.logo,
    size: (0, _styles.units)(12.5)
  })), /*#__PURE__*/_react["default"].createElement(ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(Content, null, /*#__PURE__*/_react["default"].createElement(StyledImage, imageMobile), /*#__PURE__*/_react["default"].createElement(_designSystem.Heading, {
    as: 'h1',
    color: (0, _styles.color)('primary'),
    fontWeight: 600,
    paddingTop: (0, _styles.units)(4),
    paddingTopMd: 0
  }, translate('payspaceNotFound.title')), /*#__PURE__*/_react["default"].createElement(_designSystem.Text, {
    paddingTop: (0, _styles.units)(3),
    paddingTopMd: (0, _styles.units)(6.25),
    size: 'large'
  }, translate('payspaceNotFound.lead')), /*#__PURE__*/_react["default"].createElement(_designSystem.Text, {
    color: (0, _styles.color)('gray500'),
    paddingTop: (0, _styles.units)(1),
    size: 'small'
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
      href: "mailto:".concat(supportEmail),
      key: 0,
      rel: 'noopener',
      target: '_blank'
    }, supportEmail)],
    i18nKey: 'payspaceNotFound.support',
    ns: 'common'
  }))), /*#__PURE__*/_react["default"].createElement(ActionWrapper, null, /*#__PURE__*/_react["default"].createElement(_designSystem.Text, {
    color: (0, _styles.color)('gray500'),
    marginBottom: (0, _styles.units)(1.5),
    size: 'small',
    textAlign: 'center'
  }, translate('payspaceNotFound.createPayspaceTitle')), /*#__PURE__*/_react["default"].createElement(_designSystem.Button, {
    href: earlyAccessLink,
    size: 'large'
  }, translate('payspaceNotFound.createPayspaceButton')))))));
}